/**
 * @param {(import("@evolved/domain").UserDefinedField | null)[]} udfs
 */
export const filterSelectedUdfs = (udfs) => {
  return udfs.filter(
    /** @returns {field is import("@evolved/domain").UserDefinedField} */
    (field) => !!field
  );
};
